/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { recargarComponente } from "../../redux/slices/userSlice";

function ModalComponent({ showModal, closeModal, idInscripcion, curso }) {
  const [file, setFile] = useState(null);
  const [importe, setImporte] = useState(0); // Importe total calculado
  const [metodoPago, setMetodoPago] = useState(null);
  const [metodosPago, setMetodosPago] = useState([]); // Métodos de pago disponibles
  const [parcialidadesSeleccionadas, setParcialidadesSeleccionadas] = useState(
    []
  );
  const [totalSeleccionados, setTotalSeleccionados] = useState(0);
  const email = useSelector((state) => state.user)?.email;
  const user = useSelector((state) => state.user.id);

  const [opcionPago, setOpcionPago] = useState("");
  const path = useSelector((state) => state.sitePath);
  const dispatch = useDispatch();

  const handleFileChange = (e) => setFile(e.target.files[0]);
  const handleOpcionCambio = (e) => setOpcionPago(e.target.value);

  // Esta función maneja la selección de las parcialidades
  const handleCheckboxChange = (parcialidad, isChecked) => {
    if (isChecked) {
      setTotalSeleccionados(totalSeleccionados + 1);
      setParcialidadesSeleccionadas([
        ...parcialidadesSeleccionadas,
        parcialidad,
      ]);
    } else {
      setTotalSeleccionados(totalSeleccionados - 1);
      setParcialidadesSeleccionadas(
        parcialidadesSeleccionadas.filter((item) => item !== parcialidad)
      );
    }
  };

  useEffect(() => {
    const total =
      (parseFloat(curso.costo_final) / parseFloat(curso.parcialidad)) *
      totalSeleccionados;

    setImporte(Math.ceil(total));
  }, [parcialidadesSeleccionadas]);

  useEffect(() => {
    axios
      .post(`${path}/metodos_pago.php`, { id_alumno: "" })
      .then((res) => {
        if (res.data !== "Error") {
          setMetodosPago(res.data);
        }
      })
      .catch((error) => console.log(error.response));
  }, [path]);
  useEffect(() => {
    if (!curso.parcialidad) {
      let importe_total = curso.costo_final ? curso.costo_final : curso.cuota;
      setImporte(importe_total);
    }
  }, [curso]);
  const handleRedirect = () => {
    if (importe <= 0) {
      Swal.fire({
        title: "Error",
        text: "Selecciona al menos una parcialidad para continuar.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const urlGuarda = `${path}/pago_electronico_cei.php?id_inscripcion=${idInscripcion}&importe=${importe}`;
    fetch(urlGuarda, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        if (data.type) {
          Swal.fire({
            title: "¡Registro Exitoso!",
            text: data.message,
            icon: "success",
          }).then(() => {
            const datos = data.data;
            const form = document.createElement("form");
            form.method = "POST";
            form.action = "https://fundacionunam.org/payments/index.php";
            Object.keys(datos).forEach((key) => {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = datos[key];
              form.appendChild(input);
            });
            document.body.appendChild(form);
            form.submit();
          });
        }
      });
  };

  const handleRegistra = () => {
    if (!importe || isNaN(importe) || importe <= 0 || importe == null) {
      alert("Por favor ingresa un aportación válido.");
      return false;
    }
    // if (!file) {
    //   alert("No se ha seleccionado ningún archivo.");
    //   return;
    // }

    if (!opcionPago || opcionPago === "Elige metodo de aportación") {
      alert("Por favor selecciona un método de aportación.");
      return false;
    }

    const obj = {
      to: email,
      id_grupo: curso.id,
      id_alumno: user,
      modalidad: curso.id_modalidad,
      mi_cei: parseFloat(curso.id_ins),
      parcialidad:
        parseFloat(totalSeleccionados) + parseFloat(curso.total_pagos),
      monto: importe,
      motivo_pago:
        parseFloat(totalSeleccionados) + parseFloat(curso.total_pagos) ==
        curso.parcialidad
          ? "LIQUIDACION"
          : "PARCIALIDAD",
    };
    axios
      .post(`${path}/email.php`, obj)
      .then(() => {
        Swal.fire({
          title: "¡Registro Exitoso!",
          text: `Aportación registrado exitosamente`,
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed) {
            closeModal();
            setFile(null);
            setImporte(curso.costo_final);
            setMetodoPago(null);
            dispatch(recargarComponente());
          }
        });
      })
      .catch((error) => console.error("Error:", error));
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      className='custom-modal'
    >
      <Modal.Header closeButton>
        <Modal.Title>Datos de la Aportación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='form-group'>
          <label
            htmlFor='opcionPago'
            className='col-form-label'
          >
            Opción de Aportación:
          </label>
          <select
            id='opcionPago'
            onChange={(e) => setOpcionPago(e.target.value)} // Actualizar directamente el estado
            className='form-select'
            value={opcionPago} // Asegúrate de vincular el estado actual al valor del select
          >
            <option value=''>Selecciona opción de aportación</option>
            <option value='2'>Aportación Electrónico</option>
            <option value='4'>Aportación en Cajero</option>
          </select>
        </div>

        {/* Mostrar las parcialidades si el curso es un Diplomado */}
        {curso.tipo === "Diplomado" && (
          <div className='form-group'>
            <label className='col-form-label'>
              Selecciona las parcialidades:
            </label>
            <div>
              {[...Array(parseFloat(curso.restante_parcialidades))].map(
                (_, index) => {
                  const parcialidadMonto = Math.round(
                    curso.costo_final / curso.parcialidad
                  );

                  const i = index + parseFloat(curso.total_pagos) + 1;
                  return (
                    <div key={index}>
                      <input
                        type='checkbox'
                        id={`parcialidad-${i}`}
                        onChange={(e) =>
                          handleCheckboxChange(
                            parcialidadMonto,
                            e.target.checked
                          )
                        }
                      />
                      <label htmlFor={`parcialidad-${index}`}>
                        Parcialidad {i} - ${parcialidadMonto}
                      </label>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        )}

        {/* Mostrar el importe total calculado */}
        <div className='form-group'>
          <label className='col-form-label'>Aportación total:</label>
          <input
            type='text'
            className='form-control'
            value={importe}
            disabled
          />
        </div>

        {opcionPago === "2" && (
          <Button
            variant='primary'
            onClick={handleRedirect}
          >
            Proceder con Pago Electrónico
          </Button>
        )}
      </Modal.Body>
      <Modal.Footer>
        {opcionPago !== "2" && (
          <Button
            variant='primary'
            onClick={handleRegistra}
          >
            Enviar
          </Button>
        )}
        <Button
          variant='secondary'
          onClick={closeModal}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalComponent;
